import Form from 'shared/migration-components/form';
import useFormInputs from 'shared/migration-components/form/util';
import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';

import {Card, Container, Content} from './styles';
import useResetPasswordConfirm from 'modules/auth/hooks/use-reset-password-confirm';
import useQuery from 'shared/hooks/use-query';

const ResetPasswordConfirm: React.FC = () => {
  const {getInput} = useFormInputs();
  const {key} = useQuery();
  const theme = localStorage.getItem('theme');

  return (
    <Container>
      <Content>
        <Card>
          <img
            src={theme === 'dark' ? darkLogo : logo}
            style={{
              width: 180,
              height: 120,
              alignSelf: 'center',
              marginLeft: -20,
            }}
          />
          <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
            <Form
              defaultValues={{code: key}}
              inputs={[
                getInput({name: 'password', secureText: true}),
                getInput({
                  label: 'Confirmar senha',
                  name: 'passwordConfirmation',
                  secureText: true,
                }),
              ]}
              translationKey="UserProps"
              onSubmit={useResetPasswordConfirm}
              buttonProps={{
                title: 'Alterar senha',
                widthMode: 'expand',
              }}
            />
          </div>
        </Card>
      </Content>
    </Container>
  );
};

export default ResetPasswordConfirm;
